// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DhoUA","link":"styles_link__QJq3d"};